import { motion } from "framer-motion";
import { T, useLang } from "@/lib/i18n";

const IMAGES = {
  plane: "/images/flight-wing.webp",
  clock: "/images/airport-arrivals.webp",
  badge: "/images/calendar-desk.webp",
  wallet: "/images/wallet-euros.webp",
  baby: "/images/child-seat.webp",
  moon: "/images/night-driving.webp",
};

export default function Included() {
  const { lang } = useLang();
  const t = T[lang].included;

  return (
    <section id="included" data-testid="included-section" className="relative py-24 lg:py-32 overflow-hidden">
      <img src="/images/included-bg.webp" alt="" aria-hidden="true" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-[#16110C]/50" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#16110C] via-[#16110C]/25 to-[#16110C]" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="text-center max-w-2xl mx-auto"
        >
          <p className="font-mono-label text-xs uppercase tracking-[0.28em] text-[#C5A059] mb-4">{t.overline}</p>
          <h2 className="font-serif-display font-semibold tracking-tight text-stone-100 text-3xl sm:text-4xl lg:text-5xl">
            {t.h2a}<em className="not-italic text-[#C5A059]">{t.h2b}</em>
          </h2>
        </motion.div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {t.items.map((item, i) => (
            <motion.div
              key={item.title}
              data-testid={`included-item-${item.icon}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.08, ease: "easeOut" }}
              whileHover={{ y: -6, scale: 1.03 }}
              className="group relative rounded-3xl overflow-hidden border border-stone-800 hover:border-[#C5A059]/30 transition-colors duration-500 min-h-[240px] flex flex-col justify-end"
            >
              <img
                src={IMAGES[item.icon]}
                alt={item.title}
                loading="lazy" decoding="async"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/35 to-black/10" />
              <div className="relative p-7">
                <h3 className="font-serif-display font-semibold text-2xl text-white">{item.title}</h3>
                <p className="mt-1.5 text-sm text-white/70 leading-relaxed">{item.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
